import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons'
import { Menu, MenuButton, MenuList } from '@chakra-ui/react'

import { FloorI } from '../types/types'
import { FloorDropdownItem } from './FloorDropdownItem'

interface FloorDropdownIProps {
  floors: FloorI[]
  selectedFloorName: string
  selectedFloorId: string
  onItemClick: (id: string) => void
}

export const FloorDropdown = ({
  floors,
  selectedFloorName,
  selectedFloorId,
  onItemClick,
}: FloorDropdownIProps) => {
  const handleFloorItemClick = (id: string) => {
    onItemClick(id)
  }

  return (
    <Menu autoSelect={false} gutter={0} matchWidth>
      {({ isOpen }) => (
        <>
          <MenuButton
            _hover={{ bg: '#F7F8F9' }}
            borderRadius='md'
            fontSize='20px'
            fontWeight='extrabold'
            letterSpacing='-0.6px'
            mr='15px'
            px='15px'
            py='10px'
            shadow={isOpen && '0px 2px 6px 2px rgba(0, 0, 0, 0.1)'}
            transition='all 0.2s'
          >
            {selectedFloorName}
            {isOpen ? (
              <ChevronUpIcon ml='15px' />
            ) : (
              <ChevronDownIcon ml='15px' />
            )}
          </MenuButton>
          <MenuList maxH='40vh' minW='50px' overflowY='scroll'>
            {floors?.map((floor) => (
              <FloorDropdownItem
                key={floor.id}
                onClick={() => handleFloorItemClick(floor.id)}
                selected={selectedFloorId === floor.id}
                title={floor.label}
              />
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  )
}
